import Home from "./components/Home";
import Work from "./components/Work";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Home />
      <Navbar />
      <Work />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
